import style from "../calculator.module.css";
function EditableLockedValue(props) {
  const { lockedValue, statusMode, setLockedValue, manageSurebetLockedValueFormula } = props;
  function changeLockedValue(e) {
    const { value } = e.target;
    let a13 = Number(value);
    if (isNaN(a13) === false) {
      setLockedValue(a13);
      manageSurebetLockedValueFormula({ paramLockedValue: a13 });
    }
  }
  return (
        <div>
            Valor Travado:{" "}
            <input
                className={`align-self-center form-control text-end ${statusMode
                    ? `${style.calculator_border_color_dark} ${style.calculator_text_dark_mode} ${style.calculator_bg_dark}`
                    : ""
                    }  `}
                type="number"
                defaultValue={lockedValue}
                onChange={changeLockedValue}
                style={{ width: "180px" }}
                min={0}
            />
        </div>
    );
}
export {
  EditableLockedValue
};